import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface SearchResultRowProps {
  name: string;
  path: string;
}

function SearchResultRow({name, path}: SearchResultRowProps): JSX.Element {
  return (
    <a className="list-group-item clearfix">
      {name}
      <span className="pull-right faded">{path}</span>
    </a>
  );
}

export default makeDeprecatedJadeStyleTemplate<SearchResultRowProps>(SearchResultRow);
